import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Helmet from 'components/Helmet';
import Loader from 'components/Loader';
import axios from 'config/axios';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { setError } from 'store/error';
import DigitalInstruction from 'pages/private/Digital/Instruction';
import DigitalModule from 'pages/private/Digital/Module';
// import TestModule from 'components/TestModule';
import './index.css';

function Quiz() {
    const [isLoading, setIsLoading] = useState(true);
    const [isDone, setIsDone] = useState(false);
    const [instruction, setInstruction] = useState(true);
    const [quizName, setQuizName] = useState('');
    const [quizId, setQuizId] = useState('');
    const [moduleSubject, setModuleSubject] = useState('');
    const [quizPrompt, setQuizPrompt] = useState('');
    const [moduleBreak, setModuleBreak] = useState(false);
    const [questions, setQuestions] = useState([]);
    const [questionIndex, setQuestionIndex] = useState(0);
    const [answers, setAnswers] = useState([]);
    // const [breakAfter, setBreakAfter] = useState(false);
    // const [moduleName, setModuleName] = useState('');
    // const [moduleNumber, setModuleNumber] = useState(0);
    // const [moduleDuration, setModuleDuration] = useState(null);
    // const [moduleTime, setModuleTime] = useState(null);
    // const [questionTime, setQuestionTime] = useState(0);

    const { user } = useAppSelector(state => state.user);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { courseUrl, quizNum } = useParams();

    const getNextModule = () => {
        setIsLoading(true);
        // setModuleDuration(null);
        axios.get(`courses/classroom/${courseUrl}/quiz/${quizNum}/`)
            .then(res => {
                if (res.data.id) {
                    setQuizName(res.data.name);
                    setQuizId(res.data.id);
                    setModuleSubject(res.data.subject);
                    setQuizPrompt(res.data.prompt);
                    setModuleBreak(false);
                    setQuestions(res.data.questions);
                    setAnswers(res.data.answers);
                    setQuestionIndex(0);
                    // setModuleTime(res.data.duration);
                    // setBreakAfter(res.data.breakAfter);
                    // setModuleName(res.data.name);
                    // setModuleNumber(res.data.number);
                    // setModuleDuration(res.data.duration);

                    // if (sessionStorage.getItem('autosave')) {
                    //     const autosave = JSON.parse(sessionStorage.getItem('autosave'));
                    //     if (autosave.quizId === res.data.id) {
                    //         setAnswers(autosave.answers);

                    //         setModuleDuration(autosave.moduleTime);
                    //     }
                    // }

                    setIsLoading(false);
                }
                else {
                    navigate(`result`);
                }
            })
            .catch(error => {
                // console.log(error);
                dispatch(setError(error));
            });
    }

    // useEffect(() => {
    //     axios.get(`courses/classroom/${courseUrl}/quiz/${quizNum}/`)
    //         .then(res => {
    //             // console.log(res.data);
    //             const { name, questions } = res.data;

    //             setQuizName(name);
    //             setQuestions(questions);
    //             setAnswers(questions.map(question => ({
    //                 questionId: question.id,
    //                 answer: '',
    //                 marked: false, 
    //                 timeSpent: 0
    //             })));
    //             setIsLoading(false);
    //         })
    //         .catch(error => {
    //             // console.log(error);
    //             dispatch(setError(error));
    //         });
    // }, []);
    
    useEffect(() => {
        if (isDone) {
            navigate('result', {
                replace: true
            });
        };
    }, [isDone]);

    // const sendReport = () => {
    //     axios.post('debug/', {
    //         email: user.email,
    //         message: JSON.stringify({
    //             module: `${quizName}`,
    //             answers: answers,
    //             // moduleDuration: moduleDuration,
    //             // moduleTime: moduleTime
    //         })
    //     });
    // }

    const beginTest = () => {
        setInstruction(false);
        window.scrollTo(0, 0);
    }

    const autoSave = () => {
        sessionStorage.setItem('autosave', JSON.stringify({
            quizId: quizId,
            answers: answers,
            // moduleTime: moduleTime
        }));
    }

    const navigateQuestion = (index: number) => {
        if (questionIndex >= 0 && questionIndex < questions.length) {
            let newAnswers = [...answers];
            // newAnswers[questionIndex].timeSpent += questionTime;
            setAnswers(newAnswers);
        }
        // setQuestionTime(0);
        setQuestionIndex(index);

        autoSave();
    }

    const setAnswer = (answer: string) => {
        let newAnswers = [...answers];
        newAnswers[questionIndex].answer = answer;
        setAnswers(newAnswers);

        autoSave();
    }

    const setChoice = (answer: string) => {
        let newAnswers = [...answers];
        newAnswers[questionIndex].answer = answers[questionIndex].answer == answer
            ? ''
            : answer;

        newAnswers[questionIndex].crossedOut = newAnswers[questionIndex].crossedOut.filter(value => value !== answer);
        setAnswers(newAnswers);

        autoSave();
    }

    const markQuestion = () => {
        let newAnswers = [...answers];
        newAnswers[questionIndex].marked = !answers[questionIndex].marked;
        setAnswers(newAnswers);

        autoSave();
    }

    const crossOutChoice = (choiceId: string) => {
        let newAnswers = [...answers];
        if (newAnswers[questionIndex].crossedOut.includes(choiceId)) {
            newAnswers[questionIndex].crossedOut = newAnswers[questionIndex].crossedOut.filter(value => value !== choiceId);
        }
        else {
            newAnswers[questionIndex].crossedOut.push(choiceId);
        }
        if (choiceId === answers[questionIndex].answer) {
            newAnswers[questionIndex].answer = '';
        }
        setAnswers(newAnswers);

        autoSave();
    }

    const saveAnnotation = (annotation: {
        passageId: string;
        startIndex: number;
        endIndex: number;
        annotation: string;
        html?: string;
        preview?: string;
        color?: string;
        underline?: string;
    }) => {
        let newAnswers = [...answers];
        const index = answers[questionIndex].annotations.findIndex(existing => (
            existing.passageId === annotation.passageId &&
            existing.startIndex === annotation.startIndex &&
            existing.endIndex === annotation.endIndex
        ));
        if (index >= 0) {
            newAnswers[questionIndex].annotations[index] = annotation;
        }
        else {
            const coveredAnnotations = answers[questionIndex].annotations.filter(existing => (
                existing.passageId === annotation.passageId &&
                existing.startIndex >= annotation.startIndex &&
                existing.endIndex <= annotation.endIndex
            ));

            newAnswers[questionIndex].annotations.push(annotation);

            for (let i = 0; i < coveredAnnotations.length; i++) {
                const coveredIndex = newAnswers[questionIndex].annotations.findIndex(existing => (
                    existing.passageId === coveredAnnotations[i].passageId &&
                    existing.startIndex === coveredAnnotations[i].startIndex &&
                    existing.endIndex === coveredAnnotations[i].endIndex
                ));

                const coveredAnnotation = newAnswers[questionIndex].annotations.splice(coveredIndex, 1)[0];
                newAnswers[questionIndex].annotations.push(coveredAnnotation);
            }
        }
        setAnswers(newAnswers);

        autoSave();
    }

    const deleteAnnotation = (annotation: {
        passageId: string;
        startIndex: number;
        endIndex: number;
        annotation: string;
        html?: string;
        preview?: string;
        color?: string;
        underline?: string;
    }) => {
        let newAnswers = [...answers];
        const index = answers[questionIndex].annotations.findIndex(existing => (
            existing.passageId === annotation.passageId &&
            existing.startIndex === annotation.startIndex &&
            existing.endIndex === annotation.endIndex
        ));
        if (index >= 0) {
            newAnswers[questionIndex].annotations.splice(index, 1);
        }
        setAnswers(newAnswers);

        autoSave();
    }

    const handleSubmit = () => {
        // submit quiz, get results
        // show results page

        setIsLoading(true);

        axios.post(`courses/classroom/${courseUrl}/quiz/${quizNum}/submit/`, {
            answers: answers
        })
            .then(res => {
                setIsDone(true);
                // navigate('result');
            })
            .catch(error => {
                // console.log(error);
                dispatch(setError(error));
                setIsLoading(false);
            });
    }

    const handleSaveAndExit = () => {
        setIsLoading(true);
        axios.post(`courses/classroom/${courseUrl}/quiz/${quizNum}/save/`, {
                answers: answers,
                // timeLeft: moduleTime
            })
            .then(() => {
                // exit
                navigate(-1);
            })
            .catch(error => {
                // console.log(error);
                dispatch(setError(error));
            });
    }
    
    const handleDiscardAndExit = () => {
        sessionStorage.removeItem('autosave');
        navigate(-1);
    }

    useEffect(() => {
        getNextModule();
    }, []);


    // useEffect(() => {
    //     if (!instruction && moduleDuration) setModuleTime(moduleDuration);
    // }, [instruction, moduleDuration]);

    // useEffect(() => {
    //     if (moduleTime === null) return;

    //     if (moduleTime <= 0) {
    //         handleSubmit();
    //         return;
    //     }
        
    //     const moduleTimer = setInterval(() => {
    //         setModuleTime(moduleTime - 1);
    //     }, 1000);

    //     return () => clearInterval(moduleTimer);
    // }, [moduleTime]);

    // useEffect(() => {
    //     const questionTimer = setInterval(() => {
    //         setQuestionTime(questionTime + 1);
    //     }, 1000);

    //     return () => clearInterval(questionTimer);
    // }, [questionTime]);

    if (isLoading) return <Loader />;

    return (
        <div className='digital' onCopy={(event) => { event.preventDefault() }}>
            <Helmet
                title={`${quizName ? quizName : 'Digital SAT Practice Test'} - The Digital SAT Crash Course`}
            />
            <div className='digital__box'>
                {instruction
                ?   <DigitalInstruction
                        testName={quizName}
                        beginTest={beginTest}
                    />
                :   
                    <DigitalModule
                        // moduleName={moduleName}
                        moduleName={quizName}
                        subject={moduleSubject}
                        // timeLeft={moduleTime}
                        prompt={quizPrompt}
                        questions={questions}
                        questionIndex={questionIndex}
                        answers={answers}
                        markQuestion={markQuestion}
                        crossOutChoice={crossOutChoice}
                        saveAnnotation={saveAnnotation}
                        deleteAnnotation={deleteAnnotation}
                        handleChange={value => setAnswer(value)}
                        handleSelect={value => setChoice(value)}
                        navigateQuestion={navigateQuestion}
                        handleSaveAndExit={handleSaveAndExit}
                        handleDiscardAndExit={handleDiscardAndExit}
                        handleSubmit={handleSubmit}
                    />
                
                }
            </div>
        </div>
    )
}

export default Quiz;